import React, { useState } from 'react';
import { WEBApi } from '../API/WEBApi';
import RichTextEditor from '../../components/RichTextEditor/RichTextEditor';
import ImageSelector from '../Components/ImageSelector';

const CreateBlog: React.FC = () => {
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(''); // image URL
  const [blob, setBlob] = useState(''); // ✅ blob string
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      await WEBApi.createBlog({ title, author, content, image, blob });
      setMessage('Blog created successfully!');
      setTitle('');
      setAuthor('');
      setContent('');
      setImage('');
      setBlob('');
    } catch (err) {
      setError('Failed to create blog. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h3>Create New Blog</h3>
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">Title</label>
          <input
            type="text"
            id="title"
            className="form-control"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="author" className="form-label">Author</label>
          <input
            type="text"
            id="author"
            className="form-control"
            value={author}
            onChange={e => setAuthor(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        {/* ✅ Image Selector */}
        <div className="mb-3">
          <label className="form-label">Select Image</label>
          <ImageSelector
            selectedUrl={image}
            onSelect={(url) => setImage(url)}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="blob" className="form-label">Blob</label>
          <textarea
            id="blob"
            className="form-control"
            value={blob}
            onChange={(e) => setBlob(e.target.value)}
            rows={4}
            disabled={loading}
            placeholder="Blob string or data here..."
          />
        </div>

        <div className="mb-3">
          <label htmlFor="content" className="form-label">Content</label>
          <RichTextEditor value={content} onChange={setContent} />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Creating...' : 'Create Blog'}
        </button>
      </form>
    </div>
  );
};

export default CreateBlog;
